import { Modal, Text } from "@vesatogo/grass-core"
import { Link } from "react-router-dom"
import { ReactComponent as NotReg } from "~/assets/NotReg.svg"

export type UserNotRegisteredModalProps = {
  isOpen: boolean
  onClose: () => void
}

export const UserNotRegisteredModal = ({
  isOpen,
  onClose,
}: UserNotRegisteredModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="User not Registered"
      bodyClassName="!max-w-sm"
      primaryActionButtonProps={{
        text: "Okay",
        onClick: onClose,
        className: "!rounded-lg px-8",
      }}
      secondaryActionButtonProps={{
        text: "Cancel",
        onClick: onClose,
        className: "!rounded-lg px-8",
      }}
    >
      <div className="flex flex-col items-center gap-6 text-center">
        <div className="relative">
          <div className="flex items-center justify-center">
            <NotReg />
          </div>
        </div>

        <div className="flex flex-col gap-2">
          <Text className="text-gray-800 leading-relaxed">
            Order Patti can only be created for registered Users. Please{" "}
            <Link
              className="font-600 cursor-pointer underline"
              target="_blank"
              to={{
                pathname: import.meta.env.VITE_KITE_UI + "/admin/d/farmer/new",
              }}
            >
              register here
            </Link>{" "}
            first.
          </Text>
        </div>
      </div>
    </Modal>
  )
}
